const map = {
	"./AILogo.js": 1808,
	"./AIProcessing.js": 3188,
	"./Activity.js": 3496,
	"./AlertTriangle.js": 167,
	"./ArrowRight.js": 3676,
	"./ArrowUpRight.js": 1971,
	"./Automatic.js": 2802,
	"./BarChart3.js": 2633,
	"./BaseIcon.js": 4165,
	"./BaseIconShowPage.js": 6419,
	"./Bell.js": 6904,
	"./BookMarked.js": 8340,
	"./BookOpen.js": 5532,
	"./Brain.js": 9173,
	"./BrainCircuit.js": 2806,
	"./Briefacse.js": 2389,
	"./Briefcase.js": 6093,
	"./Building.js": 9565,
	"./Building2.js": 6735,
	"./Calendar.js": 5975,
	"./CalendarDays.js": 192,
	"./ChartNoAxesCombined.js": 88,
	"./Check.js": 529,
	"./CheckCircle.js": 6041,
	"./CircleAlert.js": 1907,
	"./CircleCheck.js": 6233,
	"./CirclePause.js": 815,
	"./ClipboardList.js": 2743,
	"./Clock.js": 7823,
	"./Cloud.js": 4976,
	"./CreditCard.js": 8398,
	"./Database.js": 5400,
	"./Document.js": 5752,
	"./Download.js": 241,
	"./EyeClosed.js": 9136,
	"./EyeOpen.js": 7976,
	"./FileCheck.js": 6847,
	"./FileText.js": 6388,
	"./Folder.js": 7049,
	"./FolderOpen.js": 9361,
	"./History.js": 2657,
	"./Home.js": 5546,
	"./Incognito.js": 667,
	"./Invoice.js": 4662,
	"./Layers.js": 2647,
	"./LayoutDashboard.js": 3403,
	"./ListChecks.js": 9776,
	"./ListTodo.js": 8533,
	"./Lock.js": 8314,
	"./LogOut.js": 6271,
	"./Mail.js": 1190,
	"./MessageCircle.js": 1914,
	"./MessageSquare.js": 9513,
	"./MoreDown.js": 112,
	"./MoreUp.js": 85,
	"./Network.js": 8155,
	"./OfficeEmployee.js": 5797,
	"./Play.js": 5215,
	"./Receipt.js": 329,
	"./RupeesSymbol.js": 611,
	"./Search.js": 1929,
	"./Send.js": 5211,
	"./Settings.js": 1760,
	"./Sheild.js": 1968,
	"./ShieldCheck.js": 2774,
	"./Sparkles.js": 2962,
	"./Star.js": 2009,
	"./Sun.js": 1559,
	"./Target.js": 9380,
	"./TicketCheck.js": 9197,
	"./Trash.js": 6595,
	"./TrendingUp.js": 1317,
	"./Upload.js": 8432,
	"./UploadCloud.js": 6775,
	"./User.js": 3826,
	"./UserCheck.js": 5616,
	"./UserCog.js": 4123,
	"./UserPlus.js": 1842,
	"./Users.js": 6817,
	"./Wallet.js": 4588,
	"./Whatsapp.js": 3947,
	"./WritingHand.js": 4412
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7283;